import InvoiceForm from "./InvoiceForm";

const UpdateInvoice = () => {
    return <InvoiceForm isUpdate={true} />;
};

export default UpdateInvoice;
